import { Amplify } from 'aws-amplify'

export const configureAmplify = (): void => {
  Amplify.configure({
    Auth: {
      region: 'eu-west-2',
      userPoolId: 'eu-west-2_rnHGJxUZZ',
      userPoolWebClientId: '4hjnt8rrb9dmi604c6pu2uvq62',
      identityPoolId: 'eu-west-2:e7046934-8c81-4c45-875c-4f0b39ab60a4'
    }
  })
}
